import { Flex, Text } from '@chakra-ui/react'

const Elimination = () => {
  return (
    <Flex
      w="100%"
      mt={{
        base: '50px',
        sm: '90px',
        md: '150px',
        lg: '120px'
      }}
      flexDir="column"
      alignItems={{
        base: 'flex-start',
        lg: 'center'
      }}
    >
      <Text
        textStyle="oralcareEliminationTittle"
        textAlign="left"
        textTransform="uppercase"
        w={{
          base: '70%',
          sm: '70%',
          lg: '60%'
        }}
        color="white"
      >
        Eliminates{' '}
        <span
          style={{
            color: '#B20B0B'
          }}
        >
          99.9%
        </span>
      </Text>
      <Text
        textStyle="oralcareEliminationContent"
        textAlign="left"
        fontWeight={400}
        w={{
          base: '70%',
          sm: '70%',
          lg: '60%'
        }}
        color="white"
        mt={{
          base: '1px',
          sm: '10px',
          md: '10px',
          lg: '10px'
        }}
      >
        Cavity-causing bacteria, combating bad breath while also absorbing and
        coagulating harmful bacteria and foreign substances.
      </Text>
    </Flex>
  )
}

export default Elimination
